import React from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as campaignActions from '../../../redux/actions/CampaignsActions';
import NavigationComponent from '../../commonComponents/util/NavigationComponent';
import CampaignsFilters from './CampaignsFilters';
import CampaignsTable from './CampaignsTable';
import CreateCampaignModal from './CreateCampaignModal';
import { PermissionTypes } from '../../../lib/systemVariables';

class CampaignsPage extends NavigationComponent {
  constructor(props) {
    super(props);

    this.state = {
      showModals: {
        createCampaignModal: false
      }
    }
  }

  render() {
    return (
      <div className="page">
        <div className="subheader">
          <div className="container flex-justify">
            <h2 className="page-header">Campaigns</h2>
            <div className="action-buttons">
              {this.props.userPermissions.individuals && <Link className="btn btn-accent2 btn-small icon-left" to="/campaigns/lists">
                Manage Campaign Lists
              </Link>}
              {this.props.userPermissions.manage && <button className="btn btn-primary btn-small" onClick={this.toggleModal.bind(this, "createCampaignModal")}>Create New</button>}
            </div>
          </div>
        </div>

        <CampaignsFilters
          {...this.props.filters}
          campaignSettings={{ ...this.props.campaignSettings, locationGroups: this.props.locationGroups }}
          update={(name, value) => {
            this.props.actions.updateFilters(name, value);
            this.props.actions.getCampaignRecords(1, this.props.resultsView, this.props.sort);
          }} />

        <CampaignsTable
          {...this.props.campaignsTable}
          updateTable={this.props.actions.updateTable}
          getCampaigns={this.props.actions.getCampaignRecords}
          locations={this.props.locationGroups} />

        <CreateCampaignModal
          show={this.state.showModals.createCampaignModal}
          close={this.toggleModal.bind(this, "createCampaignModal")}
          {...this.props.newCampaign}
          categories={this.props.campaignSettings.categories}
          months={this.props.campaignSettings.months}
          locations={this.props.locationGroups}
          approvers={this.props.approvers}
          createCampaign={this.props.actions.createCampaign} />
      </div>
    );
  }
}

function mapStateToProps(state, ownProps) {
  return {
    ...state.campaigns,
    campaignsTable: state.campaignsTable,
    campaignSettings: state.settings.systemSettings.data.campaignSettings,
    locationGroups: state.settings.systemSettings.data.campaignSettings.locationGroups.filter(lg =>
      state.userProfile.profile.data.departments.indexOf(lg.department) >= 0),
    approvers: state.users.approvers.data,
    userPermissions: {
      manage: state.userProfile.permissions.data.indexOf(PermissionTypes.CampaignAndListsManage) >= 0,
      individuals: state.userProfile.permissions.data.indexOf(PermissionTypes.IndividualsManage) >= 0
    }
  }
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(campaignActions, dispatch)
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(CampaignsPage);


// WEBPACK FOOTER //
// ./src/components/campaignComponents/campaigns/CampaignsPage.jsx